<template lang="html">
  <v-card>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex
            xs12
            sm12
            md12
          >
            <v-text-field
              ref="name"
              v-model="editedRepresent.name"
              label="Наименование"
            />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
          >
            <v-text-field
              v-model="editedRepresent.remark"
              label="Примечание"
            />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
          >
            <v-checkbox
              v-model="editedRepresent.check_health"
              hide-details
              label="Проверять состояние"
            />
          </v-flex>
          <v-flex
            v-if="editedRepresent.check_health"
            xs12
            sm12
            md12
          >
            <v-text-field
              v-model="editedRepresent.health_check_ip"
              label="IP Адресс"
            />
          </v-flex>
          <v-flex
            v-if="editedRepresent.check_health"
            xs12
            sm12
            md12
          >
            <v-text-field
              v-model="editedRepresent.health_check_port"
              label="Порт"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        @click.native="addRepresentApi"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'

const API_URL = 'represents'

export default {
  name: 'Represents',
  data () {
    return {
      editedRepresent: { name: '', remark: '', parent_id: this.$route.params.parentId }
    }
  },
  methods: {
    addRepresentApi () {
      axios.post(`/api/${API_URL}/`, this.editedRepresent)
        .then((response) => {
          this.$router.push({ path: `/represents/${response.data.represent_id}` })
          this.$emit('representAdded')
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/spa/RepresentNew.vue